import { render, staticRenderFns } from "./ManagementAgilizaTable.vue?vue&type=template&id=4d2f7ee5"
import script from "./ManagementAgilizaTable.vue?vue&type=script&lang=js"
export * from "./ManagementAgilizaTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports